module.exports = __webpack_public_path__ + "static/media/oshaLogo.be8ee19c.svg";